module.exports = __webpack_public_path__ + "img/p-zhonghua.04bdc73e.png";